module.exports = __webpack_public_path__ + "static/media/manage-users.800a7694.svg";